<template>
  <v-flex xs12 row>
  	<v-layout row wrap>
  		<v-flex xs12>
  			
  		</v-flex>
  	</v-layout>

	<v-layout py-3>
   		<v-flex xs12 md8 offset-md2>
   			<v-card>
	   			<v-card-title>
            <v-text-field v-model="filter.title" label="Item Name" class="mr-3"></v-text-field>
            <search-btn @click="filterData" />
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="600px" v-if="hasCreateAccess">
              <v-btn slot="activator" round color="primary" dark small class="ml-4">Add New</v-btn>
              <v-form v-model="validForm">
                <v-card>
                  <v-card-title>
                    <span class="headline" v-text="item.id ? 'Update Raw Material' : 'Add Raw Material'"></span>
                  </v-card-title>

                  <v-card-text>
                    <v-container grid-list-md py-0>
                      <v-layout wrap>
                        <v-flex xs12 sm6>
                          <v-text-field v-model="item.title" label="Raw Material" :rules="rules" counter="50"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-autocomplete :rules="requireRule" v-model="item.unit" :items="units" item-text="title" item-value="id" label="Unit"></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-autocomplete :rules="requireRule" v-model="item.tax" :items="taxes" item-text="title" item-value="id" label="Tax"></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm6>
                          <v-text-field :rules="rateRules" counter="7" maxlength="7" v-model="item.rate" label="Rate"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 v-if="!item.id">
                          <v-text-field :rules="requireRule" counter="7" maxlength="7" v-model="item.stock_count" label="Opening Stock"></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat :disabled="processing" @click.native="close">Cancel</v-btn>
                    <v-btn color="blue darken-1" flat :disabled="!validForm || processing" :loading="processing" @click.native="item.id ? updateItem() : addItem()" v-text="item.id ? 'Update' : 'Save'"></v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-dialog>

			    </v-card-title>
	   			<v-data-table
				    :headers="headers"
				    :loading="processing"
				    :items="rawmaterials"
				    item-key="id"
				    hide-actions
            disable-initial-sort
				  >
				  	<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
				    <template slot="headerCell" slot-scope="props">
				      <v-tooltip bottom>
				        <span slot="activator">
				          {{ props.header.text }}
				        </span>
				        <span>
				          {{ props.header.text }}
				        </span>
				      </v-tooltip>
				    </template>
				    <template slot="items" slot-scope="props">
              <td>{{ props.item.title }}</td>
              <td>{{ props.item.unit_name }}</td>
              <td>{{ props.item.tax_name }}</td>
              <td>{{ props.item.rate }}</td>
              <td class="align-center justify-center layout px-0">
                <edit-btn :item="props.item" />
                <delete-btn :item="props.item" />
              </td>
				    </template>
				    <template slot="no-data" v-if="!processing && !rawmaterials.length">
				      <v-alert :value="true" color="error" icon="warning">
				        Sorry, nothing to display here :(
				      </v-alert>
				    </template>
				  </v-data-table>

          <v-pagination @loadPage="loadPage" />

          <action-dialog action="delete" :status="deleteDialog" @close="closeDeleteDialog" @success="deleteItem(rawmaterials)" />

			</v-card>
   		</v-flex>
   	</v-layout>
    
  </v-flex>
</template>

<script>

  export default {
    name: 'RawMaterials',
    data () {
      return {
        model: 'rawmaterial',
      	title: "Raw Materials",
        validForm: false,
      	processing: false,
        dialog: false,
        deleteDialog: false,
      	rawmaterials: [],
        filter: {
          title: ""
        },
        headers: [
          { text: 'Raw Material', value: 'title'},
          { text: 'Unit', value: 'unit_name'},
          { text: 'Tax', value: 'tax_name'},
          { text: 'Rate', value: 'rate'},
          { text: 'Actions', value: 'id', sortable: false }
        ],
        item: {},
        defaultItem: {
          id: "",
          title: "",
          unit: "",
          is_deleted: false
        },
        deletingItem: null,
        rules: [
          v => !!v || 'Name is required',
          v => v && v.length >= 3 || 'Must be more than 2 characters',
          v => v && v.length <= 50 || 'Maximum 50 characters allowed'
        ],
        requireRule: [
          v => !!v || 'Field is required'
        ],
        rateRules: [
            v => !!v || 'Rate is required',
            v => /^-?\s*(?=.*[0-9])\d*(?:\.\d{1,2})?\s*$/.test(v) || 'Rate must be valid'
        ]
      }
    },
    created () {
      	let breadcrumbs = [
	      	{
	          text: 'Dashboard',
	          disabled: false,
	          href: '/dashboard'
	        },
	        {
	          text: 'Raw Materials',
	          disabled: true
	        },
	        {
	          text: 'View',
	          disabled: true
	        }
       ]

      this.$store.commit('setBreadcrumbs', breadcrumbs)
      this.$store.commit('setPageTitle', 'Manage Raw Materials')
    },
    methods: {

      loadPage () {

        let api_path = this.config.apis.getRawMaterials.replace(":page", this.currentPage).replace(":perPage", this.paginationOptions.rowsPerPage)
        
        let filterArray = []

        for (const [key, val] of Object.entries(this.filter)) {
          filterArray.push(`${key}=${val}`)
        }

        api_path += '?' + filterArray.join('&')
        
        this.processing = true
        this.axios.get(api_path)
          .then((response) => {
            this.processing = false
            if (this.isSuccessResponse(response)) {
            	this.rawmaterials = response.data.data.items
              this.$store.commit('setItemsCount', response.data.data.total)
            }
            else{
            	this.rawmaterials = []
              this.$store.commit('setItemsCount', 0)
            }
          })
          .catch((error) => {
            this.processing = false
          })
      },

      addItem () {
        this.processing = true
        this.axios.post(this.config.apis.addRawMaterial, this.item)
          .then((response) => {
            if (this.isSuccessResponse(response)) {
              
              let new_item = Object.assign({}, this.item)
              new_item.id = response.data.data.id

              let unit = this.units.filter( v => v.id == new_item.unit )

              new_item.unit_name = unit ? unit[0].title : ""

              let tax = this.taxes.filter(function(item){
                return item.id == new_item.tax
              })

              new_item.tax_name = tax ? tax[0].title : ""

              this.rawmaterials.unshift(new_item)

              this.notifySuccess('insertSuccess')
              this.close()
            }
            else{
              this.notifyError('insertError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
          })
      },
      updateItem () {
      	this.processing = true
        this.axios.put(this.config.apis.updateRawMaterial.replace(":id", this.item.id), this.item)
          .then((response) => {
            if (this.isSuccessResponse(response)) {

              let unit = this.units.filter( v => v.id == this.item.unit )

              this.item.unit_name = unit ? unit[0].title : ""

              let tax = this.taxes.filter( item => item.id == this.item.tax )

              this.item.tax_name = tax ? tax[0].title : ""
              
              this.notifySuccess('updateSuccess')
              this.close()
            }
            else{
              this.notifyError('updateError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
          })
      },

      editItem (item) {
        this.item = item
        this.dialog = true
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.item = this.extend({}, this.defaultItem)
        }, 300)
      }

    },
    mounted () {
      this.getUnits()
      this.getTaxes()
      this.item = this.extend({}, this.defaultItem)
    },

    computed: {

    },

    watch: {

    }

  }
</script>
